import { Component, signal, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AuthService } from 'src/auth/services/auth.service';
import { IdleService } from 'src/auth/services/idle.service';
import { JwtService } from 'src/auth/services/jwt.service';
import { ConfigService } from 'src/shared/services/config.service';
import { RouteTypeService } from 'src/shared/services/route-type.service';

@Component({
  selector: 'cert-app-container',
  templateUrl: './app-container.component.html',
  styleUrls: ['./app-container.component.scss'],
  standalone: false,
})
export class AppContainerComponent implements OnInit, OnDestroy {
  private stop$ = new Subject<void>();
  isLoggedIn = false;
  environment?: string;

  isLoading = signal(true);

  constructor(
    private readonly authService: AuthService,
    private readonly routeTypeService: RouteTypeService,
    private readonly configService: ConfigService,
    private readonly idleService: IdleService,
    private readonly jwtService: JwtService,
    private readonly router: Router,
  ) {
    this.authService.loginChanged$.subscribe((loggedIn) => {
      this.isLoggedIn = loggedIn;
    });
  }

  ngOnInit() {
    this.authService.isLoggedIn().subscribe((isLoggedIn) => {
      this.isLoggedIn = isLoggedIn;

      if (this.isLoggedIn) {
        this.setIdleTime();
      }
    });

    this.environment = this.configService.config.environment;

    if (this.router.url == '') {
      this.routeTypeService.navigateToUserHomePage().subscribe();
    }
  }

  private setIdleTime() {
    const idleTimeoutInSeconds: number = this.configService.config.idleTimeoutInSeconds;

    this.idleService
      .createIdleTimeoutStream(idleTimeoutInSeconds * 1000, this.stop$)
      .subscribe((isTimeExpired: boolean) => {
        if (isTimeExpired) {
          console.log('Idle session timeout expired.');
          this.authService.logout();
        }
      });
  }

  ngOnDestroy(): void {
    this.stop$.next();
    this.stop$.complete();
  }
}
